/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    DistributionChannelRequest,
    DistributionChannelRequestFromJSON,
    DistributionChannelRequestToJSON,
    DistributionChannelResponse,
    DistributionChannelResponseFromJSON,
    DistributionChannelResponseToJSON,
} from '../models';

export interface ApiV2DistributionChannelDistributionChannelsPostRequest {
    distributionChannelRequest?: DistributionChannelRequest;
}

/**
 * no description
 */
export class DistributionChannelApi extends runtime.BaseAPI {

    /**
     */
    async apiV2DistributionChannelDistributionChannelsPostRaw(requestParameters: ApiV2DistributionChannelDistributionChannelsPostRequest): Promise<runtime.ApiResponse<Array<DistributionChannelResponse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/DistributionChannel/distributionChannels`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DistributionChannelRequestToJSON(requestParameters.distributionChannelRequest),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DistributionChannelResponseFromJSON));
    }

    /**
     */
    async apiV2DistributionChannelDistributionChannelsPost(requestParameters: ApiV2DistributionChannelDistributionChannelsPostRequest): Promise<Array<DistributionChannelResponse>> {
        const response = await this.apiV2DistributionChannelDistributionChannelsPostRaw(requestParameters);
        return await response.value();
    }

}
